/**
 * Enum representing user roles in the system
 * CQI_MANAGER: Admin access, can manage users and all projects
 * NATIONAL_USER: National level access, can view all counties
 * COUNTY_USER: County level access, limited to assigned county
 * FACILITY_USER: Facility level access, limited to assigned facility
 */
export enum UserRole {
  CQI_MANAGER = 'CQI_MANAGER',
  NATIONAL_USER = 'NATIONAL_USER',
  COUNTY_USER = 'COUNTY_USER',
  SUBCOUNTY_USER = 'SUBCOUNTY_USER',
  FACILITY_USER = 'FACILITY_USER'
}

/**
 * Interface representing a User
 */
export interface User {
  _id: string;
  name: string;
  email: string;
  role: UserRole;
  authSource?: 'local' | 'oidc';
  registryRole?: string;
  facility?: string;
  facilityIds?: string[];
  county?: string;
  countyId?: string;
  subCounty?: string;
  subCountyId?: string;
  chuIds?: string[];
  passwordChangeRequired?: boolean;
  createdAt: string;
  updatedAt: string;
}

/**
 * Interface for user registration
 */
export interface UserRegistration {
  name: string;
  email: string;
  password: string;
  role: UserRole;
  facility?: string;
  county?: string;
  subCounty?: string;
}

/**
 * Interface for user login
 */
export interface UserLogin {
  email: string;
  password: string;
}

/**
 * Interface for authentication response
 */
export interface AuthResponse {
  user: User;
  token: string;
}
